import { Component, OnInit, forwardRef } from '@angular/core';
import { 
    IonContent, IonSpinner
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { MarvTabsComponent, MarvTabComponent, MarvTab, MarvMessageComponent } from '@marv/components';
import { AlertItem, AlertItemComponent } from '@app/components';
import { AlertService } from '@app/services';
import { AlertMessage, AlertMessageStatus } from '@app/models';

@Component({
    selector: 'app-alert-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [
        IonContent, IonSpinner, TranslatePipe, 
        forwardRef(() => MarvTabsComponent), forwardRef(() => MarvTabComponent), forwardRef(() => MarvMessageComponent),
        forwardRef(() => AlertItemComponent)
    ]
})
export class AlertListComponent  implements OnInit {

    tabsAlerts: Array<MarvTab> = [
        {id: 'unread', label: this.translateService.instant('UNREADS'), iconPrefix: 'mail-unread-outline', countItems: 0, defaultSelected: true },
        {id: 'all', label: this.translateService.instant('ALL'), countItems: 0}
    ];

    isFetching: boolean = false;
    alertMessagesUnread: Array<AlertItem> = [];
    alertMessagesAll: Array<AlertItem> = [];

    constructor(
        private translateService: TranslateService,
        private alertService: AlertService
    ) { }

    async ngOnInit() {
        await this.getAlertMessages();
    }
    
    async getAlertMessages(){
        this.isFetching = true;
        let alertMessagesUnread: Array<AlertItem> = [];
        let alertMessagesAll: Array<AlertItem> = [];
    
        let alertMessages = await this.alertService.loadAlertMessages();
        if(alertMessages){
            alertMessages.sort((a, b) => {
                return b.date.getTime() - a.date.getTime();
            });
            alertMessages.forEach(m => {
                if(m.status.code === AlertMessageStatus.Status.UNREAD){
                    alertMessagesUnread.push(AlertItem.FromAlertMessage(m));
                }                
                alertMessagesAll.push(AlertItem.FromAlertMessage(m));                
            });
        }
        
        this.alertMessagesUnread = alertMessagesUnread;
        this.alertMessagesAll = alertMessagesAll;
        
        let tabUnread = this.tabsAlerts.find(t => t.id === 'unread');
        if(tabUnread){
            tabUnread.countItems = this.alertMessagesUnread.length;
        }
        
        let tabAll = this.tabsAlerts.find(t => t.id === 'all');
        if(tabAll){
            tabAll.countItems = this.alertMessagesAll.length;
        }
        
        this.isFetching = false;
    }

}
